<template>
  <h1 class="text-center">Newsletters</h1>
</template>

<script>
export default {
  name: "Newsletters"
}
</script>

<style scoped>

</style>